import Vue from 'vue'
import App from './App.vue'
import store from './store/store';
import router from "./routes/router";
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import VueCookie from 'vue-cookie'
import VueSweetalert2 from 'vue-sweetalert2';
import VueCurrencyFilter from 'vue-currency-filter';
import moment from 'moment';
import VueNumeric from 'vue-numeric'

moment.locale('es');

Vue.config.productionTip = false;
Vue.use(VueCookie);
Vue.use(VueSweetalert2);
Vue.use(ArgonDashboard);
Vue.use(VueNumeric);

Vue.use(VueCurrencyFilter, {
    symbol: '€',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'end',
    symbolSpacing: true
});

Vue.filter('parseDate', function (date) {
    if (date) {
        var humanDate = moment(date);
        return moment(humanDate).format("DD-MM-YYYY");
    } else {
        return "";
    }
});

Vue.filter('parseDateHour', function (date) {
    if (date) {
        var humanDate = moment(date);
        return moment(humanDate).format("DD-MM-YYYY HH:mm:ss");
    } else {
        return "";
    }
});

Vue.filter('capitalizeText', function (text) {
    if (typeof text !== 'string') return ''
    return text.toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ')
        .trim();
});

Vue.filter('parseSedePago', function (text) {
    switch (text) {
        case 'Sevilla Este':
            return 'SEV';
        case 'Torreblanca':
            return 'TOR';
        case 'Castilleja Cuesta':
            return 'CAS';
        case 'Santiponce':
            return 'SAN';
    }
});


Vue.filter('parseDiaPago', function (text) {
    if (text == 'Miércoles') {
        return 'X';
    } else {
        return text.slice(0, 1);
    }
});

Vue.filter('parseGrupo', function (group) {
    var portero = "";
    if (group.portero == 1) {
        portero = "PORTERO";
    }

    var type = "";
    if (group.maxplayers == 8) {
        type = "8 jugadores - ";
    } else if (group.maxplayers == 4) {
        type = "4 jugadores - ";
    } else if (group.maxplayers == 1) {
        type = "Individual - ";
    }

    if (group.year5 != "") {
        return type + portero + " " + group.sede + " / " + group.dia + " (" + group.year + " / " + group.year2 + " / " + group.year3 + " / " + group.year4 + " / " + group.year5 + ") " + group.hora;
    } else if (group.year4 != "") {
        return type + portero + " " + group.sede + " / " + group.dia + " (" + group.year + " / " + group.year2 + " / " + group.year3 + " / " + group.year4 + ") " + group.hora;
    } else if (group.year3 != "") {
        return type + portero + " " + group.sede + " / " + group.dia + " (" + group.year + " / " + group.year2 + " / " + group.year3 + ") " + group.hora;
    } else if (group.year2 != "") {
        return type + portero + " " + group.sede + " / " + group.dia + " (" + group.year + " / " + group.year2 + ") " + group.hora;
    } else {
        return type + portero + " " + group.sede + " / " + group.dia + " (" + group.year + ") " + group.hora;
    }
});

Vue.filter('parseMesPago', function (mes) {
    mes = parseInt(mes);
    switch (mes) {
        case 0:
            return 'Octubre';
        case 1:
            return 'Noviembre';
        case 2:
            return 'Diciembre';
        case 3:
            return 'Enero';
        case 4:
            return 'Febrero';
        case 5:
            return 'Marzo';
        case 6:
            return 'Abril';
        case 7:
            return 'Mayo';
        case 8:
            return 'Junio';
    }
});

Vue.filter('parseModalidad', function (modalidad) {
    let maxPlayers = modalidad.name;
    // switch (modalidad.maxPlayers || modalidad.max_players) {
    //     case 8:
    //         maxPlayers = 'Grupo reducido';
    //         break;
    //     case 4:
    //         maxPlayers = 'Grupo 4 jugadores';
    //         break;
    //     case 1:
    //         maxPlayers = 'Grupo individual';
    //         break;
    //     case 2:
    //         maxPlayers = 'Dual';
    //         break;
    // }

    // const day = modalidad.days === 1 ? '1 día' : '2 días';
    // const gym = modalidad.gym ? ' + GYM)' : ')';

    return maxPlayers + ' - ' + modalidad.price + ' €';
});

Vue.filter('parseDia', function (dia) {
    switch (dia) {
        case 0:
           return 'Domingo';
        case 1:
            return 'Lunes';
        case 2:
            return 'Martes';
        case 3:
            return 'Miércoles';
        case 4:
            return 'Jueves';
    }
});


new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app');
